const headerTranslations = {
  mealsPdfButton: "ملف الوجبات",
  exercisesPdfButton: "ملف التمارين",
};

export default headerTranslations;
